import LWForm, { type LWFormProps } from 'components/LWForm';
import {
	useDialogMakePaymentContext,
	type DialogMakePaymentFormValues,
	type DialogMakePaymentFormErrors,
} from '../dialogMakePaymentContext';

const MakePaymentForm = (
	props: Omit<
		LWFormProps<DialogMakePaymentFormValues, DialogMakePaymentFormErrors>,
		'values' | 'errors' | 'onValuesChange' | 'onErrorsChange'
	>,
) => {
	const { formErrors, formValues, setFormErrors, setFormValues } =
		useDialogMakePaymentContext();

	return (
		<LWForm
			{...props}
			values={formValues}
			errors={formErrors}
			onValuesChange={setFormValues}
			onErrorsChange={setFormErrors}
		/>
	);
};

export default MakePaymentForm;
